import { Collection } from 'modules/core/lib/mobx-rest'

import ShiftConfiguration from 'modules/shift_management/store/api/models/ShiftConfiguration'

class ShiftConfigurations extends Collection<ShiftConfiguration> {
  get cacheKey(): string {
    return 'shiftConfigurations'
  }
  model() {
    return ShiftConfiguration
  }
}

const singleton: ShiftConfigurations = new ShiftConfigurations()

export default singleton
